<div class="location-container">
  <div
    *ngFor="let locationTile of locationTileList; let i = index; let isLastChild = last"
    [style.marginBottom]="!isLastChild ? '1.25rem' : '0'"
  >
    <app-landing-location-tile
      [locationData]="locationTile"
      [isPreferred]="i === 0"
    ></app-landing-location-tile>
  </div>
</div>